import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import { DetailDataChanges } from "../partial/OrderRequestDetailDialog.partial";

/** check the error of catering quantity changes */
export const checkCateringDetailError = (
  props: DetailDataChanges,
  editedData: DetailedServiceBookingData | null
) => {
  const { id, newQty } = props;

  // Validate quantity only for catering type
  const selected = editedData?.caterings.find(cat => cat.id === id);
  const maxQty = selected?.orderedQty || selected?.quantity || 5;
  const nullAvailableQty = selected?.availableQty === null;

  if (!newQty || newQty <= 0) {
    return "min";
  } else if (newQty > maxQty) {
    return "max";
  } else if (nullAvailableQty) {
    return "empty";
  }
  return null;
};
